import React, { useEffect, useState } from 'react'
import styles from './styles.module.scss'
import BaseLoading from '@/src/components/helpers/base-loading/base-loading'
import CreateElements from '@/src/components/helpers/create-elements/create-elements'

interface LoadingCategoriesProps {
    loadingOnProducts?: boolean
}

export default function LoadingCategories({ loadingOnProducts }: LoadingCategoriesProps) {

    const [randomNumber, setRandomNumber] = useState(1)

    useEffect(() => {
        setRandomNumber(Math.floor(Math.random() * (10 - 6 + 1) + 6))
    }, [])

    if (loadingOnProducts) {
        return (
            <BaseLoading>
                <section className={`${styles.container} ${styles.marginTop}`}>
                    <div className={styles.cardsList}>
                        <CreateElements quantity={randomNumber}>
                            <div className={styles.card}>
                                <aside className={styles.image} />
                                <div className={styles.descriptionArea}>
                                    <aside className={styles.name} />
                                    <aside className={styles.description} />
                                    <aside className={styles.price} />
                                </div>
                            </div>
                        </CreateElements>
                    </div>
                </section>
            </BaseLoading>
        )
    }

    return (
        <BaseLoading>
            <section className={styles.container}>
                <CreateElements quantity={randomNumber - 1}>
                    <aside className={styles.title} />
                    <div className={styles.cardsList}>
                        <CreateElements quantity={randomNumber}>
                            <div className={styles.card}>
                                <aside className={styles.image} />
                                <div className={styles.descriptionArea}>
                                    <aside className={styles.name} />
                                    <aside className={styles.description} />
                                    <aside className={styles.price} />
                                </div>
                            </div>
                        </CreateElements>
                    </div>
                </CreateElements>
            </section>
        </BaseLoading>
    )
}